function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/node_modules/@babel/runtime/helpers/iterableToArray.js
// module id = 955
// module chunks = 0